export default __webpack_public_path__ + "static/media/sh_8.63de7195.png";